import React from "react";
import { AiThinking, AiResult } from "./Components";
import "./ScenarioResult.scss";
import useResults from "../../../../hooks/useResults";
import Error from "../../../../assets/error.svg";
import { Success } from "../../../../modals";
import { useNavigate } from "react-router-dom";

const ScenarioResult = () => {
  const navigate = useNavigate();
  const {
    results,
    isModalOpened,
    chosenItem,
    isSuccessModalOpened,
    selectedItems,
    isErrorModalOpened,
    isSavedCareer,
    handleModalOpen,
    closeModal,
    handlescore,
    handleBook,
    closeSuccessModal,
    handleSaveCareer,
    persistScore,
    persistSortDecision,
    showLoader,
  } = useResults(true);

  const handleBookRedirect = () => {
    handleBook(null, false);
    navigate(`/profile/recommendations/career/${chosenItem.id}`);
  };

  return (
    <div className="ScenarioResult">
      {results?.length >= 10 ? (
        <AiResult
          data={results}
          isModalOpened={isModalOpened}
          handleModalOpen={handleModalOpen}
          closeModal={closeModal}
          handleSaveCareer={handleSaveCareer}
          persistScore={persistScore}
          persistSortDecision={persistSortDecision}
          chosenItem={chosenItem}
          handlescore={handlescore}
          handleBook={handleBookRedirect}
          isSuccessModalOpened={isSuccessModalOpened}
          closeSuccessModal={closeSuccessModal}
          isSavedCareer={isSavedCareer}
          selectedItems={selectedItems}
          showLoader={showLoader}
        />
      ) : (
        <AiThinking />
      )}

      <Success
        image={Error}
        title=""
        text={isErrorModalOpened}
        isOpened={isErrorModalOpened}
        close={() => {
          navigate("/pricingplan");
        }}
      />
    </div>
  );
};

export default ScenarioResult;
